// extracted by mini-css-extract-plugin
export default {"fullWidth":"To-z","image":"Uo-z","lazyLoadPicture":"Vo-z","lazyLoadSpinner":"Wo-z","lazyLoadSpin":"Xo-z","lazyLoadImage":"Yo-z","hasStyledAspectRatio":"Zo-z"};